import { useEffect, useState } from "react";
import { Heading } from "@chakra-ui/layout";
import { NumberInput, NumberInputField } from "@chakra-ui/number-input";
import FancyText from "../FancyText";
import { Tooltip } from "@chakra-ui/tooltip";

function Header({ wordCloudData }) {
  const { sumTotal, data } = wordCloudData;
  const [wordCount, setWordCount] = useState(100);
  const [percent, setPercent] = useState();
  const sumTop = data.slice(0, wordCount).reduce((a, b) => a + (b["weight"] || 0), 0);

  const calculatePercentage = (top, total) => {
    const percentage = (top / total) * 100;
    const result = Math.round(percentage * 10) / 10;
    return result;
  };
  useEffect(() => {
    const percentage = calculatePercentage(sumTop, sumTotal);
    setPercent(percentage);
  }, [wordCount, setPercent, wordCloudData, sumTop, sumTotal]);
  return (
    <>
      {/* Info Bubble Top 100: 19330 Videos watched, total: 202013 Videos watched */}
      <Heading fontWeight={100} maxWidth="1000px" width="100%" textAlign="center">
        {`The top`}
        <NumberInput
          defaultValue={100}
          min={1}
          size="lg"
          display="inline-block"
          maxW={"24"}
          mx={2}
          textAlign="center"
          style={{ textAlignLast: "center" }} // needed in chrome
          value={wordCount}
          onChange={(value) => {
            setWordCount(value);
          }}
        >
          <NumberInputField fontWeight="medium" fontSize="3xl" />
        </NumberInput>
        {`Channels make up `}
      </Heading>
      <Heading fontWeight={100} maxWidth="1000px" width="100%" textAlign="center" mb="10">
        <FancyText>
          <Tooltip
            label={`Total video impressions: ${sumTotal}, Top ${wordCount}: ${sumTop}`}
            aria-label="A tooltip"
          >
            {`${percent}%`}
          </Tooltip>
        </FancyText>
        {` of your total video impressions`}
      </Heading>
    </>
  );
}

export default Header;
